import { Button, Popover, PopoverContent, PopoverDialog } from "@heroui/react";
import { GENERATION_FAILURE_REASON_LABELS, GENERATION_FAILURE_REASON_VALUES, type GenerationFailureReason } from "@storyline/shared";
import { useState } from "react";
import { FAILURE_REASON_DETAILS } from "@/src/stories/constants/contact-copy";

type RegenerateControlProps = {
	isBusy: boolean;
	costUsd: number;
	label?: string;
	onRegenerate: (reason: GenerationFailureReason) => void;
};

const RegenerateControl: React.FC<RegenerateControlProps> = ({ isBusy, costUsd, label = "Régénérer", onRegenerate }) => {
	const [isOpen, setIsOpen] = useState(false);

	const choose = (reason: GenerationFailureReason): void => {
		setIsOpen(false);
		onRegenerate(reason);
	};

	return (
		<Popover isOpen={isOpen} onOpenChange={setIsOpen}>
			<Button size="sm" variant="secondary" isDisabled={isBusy} className="w-full">
				↻ {label}
			</Button>
			<PopoverContent>
				<PopoverDialog className="flex w-80 max-w-[92vw] flex-col gap-2 p-3">
					<div className="flex flex-col gap-0.5">
						<span className="font-semibold text-foreground text-sm">Pourquoi régénérer ?</span>
						<span className="text-muted text-xs">
							Choisis le motif : le serveur adapte sa stratégie de reprise. Coût ~{costUsd.toFixed(2)} $ par génération.
						</span>
					</div>
					<div className="flex flex-col gap-1">
						{GENERATION_FAILURE_REASON_VALUES.map((reason) => (
							<button
								key={reason}
								type="button"
								onClick={() => choose(reason)}
								className="flex flex-col gap-0.5 rounded-lg border border-border-soft p-2 text-left transition hover:border-accent-lav hover:bg-accent-soft"
							>
								<span className="font-semibold text-foreground text-xs">{GENERATION_FAILURE_REASON_LABELS[reason]}</span>
								<span className="text-muted text-xs">{FAILURE_REASON_DETAILS[reason].description}</span>
								<span className="text-accent-lav text-xs">→ {FAILURE_REASON_DETAILS[reason].serverAction}</span>
							</button>
						))}
					</div>
				</PopoverDialog>
			</PopoverContent>
		</Popover>
	);
};

export default RegenerateControl;
